<template>
  <DialogLayout :class-name="'confirm-dialog'" @close="handleClose" :style="{
    width: width + 'px'
  }">
    <template #title>{{ title }}</template>
    <template #default>
      <div class="confirm-content">
        <component v-if="contentComponent" :is="contentComponent" />
        <template v-else>{{ content }}</template>
      </div>
    </template>
    <template #footer>
      <el-button
        v-for="(btn, index) in otherButtons"
        :key="index"
        class="confirm-button"
        :type="btn?.type"
        :plain="btn?.plain"
        @click="handleOtherButton(btn)"
      >
        {{ btn.text }}
      </el-button>
      <div style="flex: 1;"></div>
      <el-button
        v-if="cancelButton !== false"
        :type="cancelButton?.type"
        :plain="cancelButton?.plain"
        class="confirm-button confirm-button-default"
        @click="handleCancel"
      >
        {{ cancelButtonText }}
      </el-button>
      <el-button
        class="confirm-button"
        :type="confirmButton?.type"
        :plain="confirmButton?.plain"
        :class="`confirm-button-${confirmButton.type || 'primary'}`"
        @click="handleConfirm"
      >
        {{ confirmButton.text }}
      </el-button>
    </template>
  </DialogLayout>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import type { ConfirmModalProps } from './confirm-types';
import DialogLayout from '@/components/business-components/dialog/dialog-layout.vue';

const props = withDefaults(
  defineProps<ConfirmModalProps>(),
  {
    title: '提示',
    showClose: true,
  }
);

const emit = defineEmits<{
  cancel: [data?: any];
  confirm: [data?: any];
  close: [data?: any];
}>();

const cancelButtonText = computed(() => {
  if (props.cancelButton === false) return '';
  return props.cancelButton?.text || '取消';
});

const handleCancel = async () => {
  let result: any = undefined;
  if (props.cancelButton !== false && props.cancelButton?.onClick) {
    result = await props.cancelButton.onClick();
  }
  emit('cancel', result);
};

const handleConfirm = async () => {
  let result: any = undefined;
  if (props.confirmButton?.onClick) {
    result = await props.confirmButton.onClick();
  }
  emit('confirm', result);
};

const handleClose = () => {
  emit('close');
};

const handleOtherButton = async (btn: any) => {
  if (btn?.onClick) {
    await btn.onClick();
  }
  // Don't close the dialog automatically for other buttons
};
</script>

<style lang="scss" scoped>
.confirm-dialog {
  min-width: 416px;
  background: #ffffff;
  // border-radius: 8px;
  overflow: hidden;
}

.confirm-content {
  font-size: 14px;
  line-height: 22px;
  color: #495057;
  word-break: break-word;
  white-space: pre-line;
}

.confirm-button {
  min-width: 72px;
  height: 35px;
  padding: 4px 16px;
  font-size: 14px;
  line-height: 22px;
  // border-radius: 4px;
  // border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.3s;
  outline: none;

  &:active {
    transform: translateY(1px);
  }
}
.confirm-button:not(.is-plain) {
  // border: 1px solid transparent;
}
.confirm-button-default {
  background: #ffffff;
  // border: none;
  color: #495057;
  font-weight: normal;
  cursor: pointer;
  &:hover {
    color: var(--el-color-primary);
  }
}

.confirm-button-primary {
  background: var(--el-color-primary);
  color: #ffffff;
  cursor: pointer;

  &:hover:not(.is-plain) {
    background: var(--el-color-primary);
  }
}

.confirm-button-danger {
  background: var(--el-color-danger);
  color: #ffffff;
  cursor: pointer;

  &:hover {
    background: var(--el-color-danger);
  }
}

.confirm-button-success {
  background: var(--el-color-success);
  color: #ffffff;

  &:hover {
    background: var(--el-color-success);
  }
}

.confirm-button-warning {
  background: var(--el-color-warning);
  color: #ffffff;

  &:hover {
    background: var(--el-color-warning);
  }
}
</style>
